export default "__VITE_ASSET__111401be__"